import { i18n } from "@lib/i18n";
import { rootRoute } from "@routes";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

export const signUpRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: `signup`,
    component: lazyRouteComponent(() => import("./SignUp")),
    beforeLoad: () => ({ getTitle: () => i18n.sign_up_title() }),
});
